import { ServiceClient } from 'src/utils'
import type {
    AccessByGroupRow,
    AccessByPageRow,
    AccessByUserRow,
    AccessAuditFilter,
    AccessDetail,
    AccessFilterOptions,
    AccessInactiveUserRow,
    AccessPeriodRow,
    AccessSummary
} from './aa_types'

const serviceClient = ServiceClient.singleton()

export class AccessAuditService {
    static #INSTANCE = new AccessAuditService()
    static readonly singleton = () => AccessAuditService.#INSTANCE

    async fetchSummary(filter: AccessAuditFilter) {
        return serviceClient.authGet<AccessSummary>(url('/api/access-log/summary', filter))
    }

    async fetchByGroup(filter: AccessAuditFilter) {
        return serviceClient.authGet<AccessByGroupRow[]>(url('/api/access-log/by-group', filter))
    }

    async fetchByUser(filter: AccessAuditFilter) {
        return serviceClient.authGet<AccessByUserRow[]>(url('/api/access-log/by-user', filter))
    }

    async fetchByPage(filter: AccessAuditFilter) {
        return serviceClient.authGet<AccessByPageRow[]>(url('/api/access-log/by-page', filter))
    }

    async fetchInactiveUsers(filter: AccessAuditFilter) {
        return serviceClient.authGet<AccessInactiveUserRow[]>(url('/api/access-log/inactive-users', filter))
    }

    async fetchMonthly(filter: AccessAuditFilter) {
        return serviceClient.authGet<AccessPeriodRow[]>(url('/api/access-log/monthly', filter))
    }

    async fetchDaily(filter: AccessAuditFilter) {
        return serviceClient.authGet<AccessPeriodRow[]>(url('/api/access-log/daily', filter))
    }

    async fetchDetail(filter: AccessAuditFilter) {
        return serviceClient.authGet<AccessDetail>(url('/api/access-log/detail', filter))
    }

    async fetchFilterOptions() {
        return serviceClient.authGet<AccessFilterOptions>('/api/access-log/filter-options')
    }
}

function url(path: string, filter: AccessAuditFilter): string {
    const params = new URLSearchParams()

    if (filter.start) {
        params.set('start', filter.start)
    }
    if (filter.end) {
        params.set('end', filter.end)
    }
    if (filter.groupId) {
        params.set('groupId', String(filter.groupId))
    }
    if (filter.userId) {
        params.set('userId', String(filter.userId))
    }
    if (filter.placeCode) {
        params.set('placeCode', filter.placeCode)
    }

    const query = params.toString()
    return query ? `${path}?${query}` : path
}

export default AccessAuditService.singleton()
